export const request = "/requests";
export const addRequest = "/requests";
export const status = "/requests";
export const valuation = "/requests/set-car-valuation";
export const getSalesPErson = "user/find-by-role";
export const assignSalesperson = "/requests";
export const requestDetail = "requests/get-request-by-id";


